import { render, staticRenderFns } from "./comparison-table.view.vue?vue&type=template&id=a86ff916&scoped=true&"
import script from "./comparison-table.view.vue?vue&type=script&lang=ts&"
export * from "./comparison-table.view.vue?vue&type=script&lang=ts&"
import style0 from "./comparison-table.view.vue?vue&type=style&index=0&id=a86ff916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86ff916",
  null
  
)

export default component.exports